import { dynamicLoader } from '~/utils';

export const ServiceAreasPage = dynamicLoader({
  name: 'ServiceAreasPage',
  importFunc: () => import('./service-areas'),
});